import { Container, Row, Col } from "react-bootstrap";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Services = () => {
  const windowHeight = window.innerHeight;

  useEffect(() => {
    const reveal = (className) => {
      var reveals = document.querySelectorAll(className);

      for (var i = 0; i < reveals.length; i++) {
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    };

    window.addEventListener("scroll", () => {
      reveal(".reveal");
      reveal(".reveal2");
      reveal(".reveal3");
      reveal(".reveal4");
    });

    reveal(".reveal");
    reveal(".reveal2");
    reveal(".reveal3");
    reveal(".reveal4");

    return () => {
      window.removeEventListener("scroll", () => {
        reveal(".reveal");
        reveal(".reveal2");
        reveal(".reveal3");
        reveal(".reveal4");
      });
    };
  }, [windowHeight]);

  return (
    <>
      <Helmet>
        <title>Usługi | Anten-Sat</title>
        <meta
          name="description"
          content="Oferujemy profesjonalny montaż i ustawianie anten w Częstochowie i okolicach. Sprawdź nasze usługi!"
        />
        <link rel="canonical" href="https://antensat.pl/services" />
      </Helmet>

      <Container fluid className="hero">
        <Row className="p-4">
          <h1 className="reveal3">WYKONYWANE PRZEZ NAS USŁUGI</h1>
          <Row className="gap-5 my-3 justify-content-center">
            <Col lg={3} md={5} sm={12} className="p-4 services-col reveal">
              <h5 className="services-h5 ">INSTALACJE ANTENOWE</h5>
              <p>
                Specjalizujemy się w instalacjach antenowych w budynkach
                przemysłowych i obiektach prywatnych. Oferujemy montaż anten
                kierunkowych, szerokopasmowych oraz zestawów satelitarnych,
                zapewniając optymalny odbiór sygnału.
              </p>
              <img
                src="/img/services1.jpg"
                className="img-fluid "
                alt="Opening-hours"
              />
            </Col>
            <Col lg={3} md={5} sm={12} className="p-4 services-col reveal2">
              <h5 className="services-h5">POMIAR SYGNAŁU</h5>
              <p>
                Dokonujemy precyzyjnych pomiarów sygnału TV i satelitarnego, aby
                zapewnić najwyższą jakość odbioru. Nasze doświadczenie pozwala
                nam na szybką diagnozę i optymalizację instalacji.
              </p>
              <img
                src="/img/services2.jpg"
                className="img-fluid "
                alt="Opening-hours"
              />
            </Col>
            <Col lg={3} md={5} sm={12} className="p-4 services-col reveal3">
              <h5 className="services-h5">TELEWIZJA PRZEMYSŁOWA (CCTV)</h5>
              <p>
                Oferujemy kompleksowe rozwiązania z zakresu telewizji
                przemysłowej, w tym montaż kamer oraz systemów monitoringu, aby
                zwiększyć bezpieczeństwo Twojego obiektu.
              </p>
              <img
                src="/img/services3.jpg"
                className="img-fluid "
                alt="Opening-hours"
              />
            </Col>
            <Col lg={3} md={5} sm={12} className="p-4 services-col reveal4">
              <h5 className="services-h5">SYSTEMY ZABEZPIECZEŃ</h5>
              <p>
                Instalujemy nowoczesne systemy sygnalizacji włamania i napadu,
                zapewniając najwyższy poziom ochrony dla Twojego mienia.
                Dostosowujemy rozwiązania do indywidualnych potrzeb klientów.
              </p>
              <img
                src="/img/services4.jpg"
                className="img-fluid "
                alt="Opening-hours"
              />
            </Col>
            <Col lg={3} md={5} sm={12} className="p-4 services-col reveal2">
              <h5 className="services-h5">SPRZEDAŻ DEKODERÓW</h5>
              <p>
                Oferujemy szeroki wybór dekoderów do telewizji cyfrowej i
                satelitarnej, które umożliwiają odbiór wysokiej jakości sygnału.
                Nasz zespół pomoże w doborze odpowiedniego modelu, dostosowanego
                do Twoich potrzeb.
              </p>
              <img
                src="/img/services5.jpg"
                className="img-fluid "
                alt="Opening-hours"
              />
            </Col>
            <Col lg={3} md={5} sm={12} className="p-4 services-col reveal">
              <h5 className="services-h5">SERWIS I KONSERWACJA</h5>
              <p>
                Oferujemy serwisowanie i konserwację sprzętu elektronicznego, w
                tym kamer, telewizorów i systemów RTV. Dbamy o to, aby Twój
                sprzęt działał sprawnie przez wiele lat.
              </p>
              <img
                src="/img/services6.jpg"
                className="img-fluid "
                alt="Opening-hours"
              />
            </Col>
          </Row>
          <p>
            Jeśli jesteś zainsteresowany/a którąś z naszych usług{" "}
            <Link to="/contact">skontaktuj się z nami</Link>!
          </p>
        </Row>
        <hr className="custom-hr" />
      </Container>
    </>
  );
};

export default Services;
//
